import React from 'react';
import VariablePill from './VariablePill';
// Mirrors the BE compiler's _VAR_RE so only substitutable placeholders become pills.
const VAR_PATTERN = /\{\{(\w+)\}\}/g;
const renderTextWithVariables = (text: string): React.ReactNode => {
    const parts: React.ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    let key = 0;
    const regex = new RegExp(VAR_PATTERN.source, 'g');
    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(text.slice(lastIndex, match.index));
        }
        parts.push(<VariablePill key={key++} variableKey={match[1]} />);
        lastIndex = regex.lastIndex;
    }
    if (lastIndex < text.length) {
        parts.push(text.slice(lastIndex));
    }
    return parts.length > 0 ? parts : text;
};
export default renderTextWithVariables;
